import { Attributes } from "../shared/types/attributes.type";
import { ICopyable } from "../shared/interfaces/copyable.interface";

export enum TypologyEnum {
  PERCENTAGE = "percentage",
  AMOUNT = "amount",
}

export enum InsuranceCalculationBaseEnum {
  ACCOMMODATION_AND_EXTRAS = "accommodationAndExtras",
  ACCOMMODATION_ONLY = "accommodationOnly",
}

export interface TranslationEntity {
  locale: string;
  name: string;
  description: string;
}

export interface BookableRefInventoryEntity {
  tickersList: string[];
}

export interface TypologySectionEntity {
  amountFrom: number;
  amountTo: number;
  value: number;
}

export interface TypologyPercentageEntity {
  sectionsList: TypologySectionEntity[];
}

export interface TypologyAmountEntity {
  sectionsList: TypologySectionEntity[];
}

export interface TypologyEntity {
  percentage?: TypologyPercentageEntity;
  amount?: TypologyAmountEntity;
}

export interface RestrictionsEntity {
  minStay?: number;
  maxStay?: number;
  minNotice?: number;
  maxNotice?: number;
}

export interface InsuranceTaxationEntity {
  id: string;
  ticker: string;
}

export type InsuranceEntityProps = Attributes<InsuranceEntity>;

export class InsuranceEntity implements ICopyable<InsuranceEntity> {
  private constructor(
    readonly id: string,
    readonly type: TypologyEnum,
    readonly calculationBase: InsuranceCalculationBaseEnum,
    readonly ticker: string,
    readonly active: boolean,
    readonly translationsList: TranslationEntity[],
    readonly appliesToInventories: BookableRefInventoryEntity,
    readonly taxes: InsuranceTaxationEntity[],
    readonly fees: InsuranceTaxationEntity[],
    readonly typology: TypologyEntity,
    readonly restrictions: RestrictionsEntity,
    readonly validFrom?: Date,
    readonly validTo?: Date,
    readonly createdAt?: Date,
    readonly updatedAt?: Date
  ) {}

  copy(props: Partial<Attributes<InsuranceEntityProps>>): InsuranceEntity {
    return InsuranceEntity.of({ ...this, ...props });
  }

  static of(props: InsuranceEntityProps) {
    return new InsuranceEntity(
      props.id,
      props.type,
      props.calculationBase,
      props.ticker,
      props.active,
      props.translationsList,
      props.appliesToInventories,
      props.taxes,
      props.fees,
      props.typology,
      props.restrictions,
      props.validFrom,
      props.validTo,
      props.createdAt,
      props.updatedAt
    );
  }
}
